<template>
	<button
		:class="[
			'rounded-lg',
			disableText ? 'py-3' : 'py-4',
			disableText ? 'px-5' : 'px-3',
			'float-inherit',
			'text-white',
			buttonClass,
			'hover:bg-blue-700',
			'focus:outline-none',
			'text-sm',
			'font-semibold',
			'max-h-50',
			{ 'opacity-50 cursor-not-allowed': disabled },
			{ 'flex items-center': iconBefore || iconAfter },
			{ 'justify-center': !iconBefore && !iconAfter },
		]"
		:disabled="disabled"
		:icon="icon"
		@click="handleClick"
	>
		<span v-if="iconBefore" :class="{ 'mr-2': !disableText }">
			<i :class="iconBefore"></i>
		</span>
		<span :class="{ 'ml-2': !disableText }">
			<slot name="iconBeforeImg"></slot>
		</span>
		<span v-if="!disableText" :class="{ 'ml-2': !disableText }">{{
			buttonText
		}}</span>
		<span :class="{ 'ml-2': !disableText }">
			<slot name="iconAfterImg"></slot>
		</span>
		<span v-if="iconAfter" :class="{ 'mr-2': !disableText }">
			<i :class="iconAfter"></i>
		</span>
	</button>
</template>

<script>
export default {
	name: "NSButton",
	props: {
		buttonText: {
			type: String,
			default: "Enter Text...",
		},
		iconBefore: {
			type: String,
			default: null,
		},
		// iconBeforeImg: {
		//     type: String,
		//     default: null,
		// },
		iconAfter: {
			type: String,
			default: null,
		},
		// iconAfterImg: {
		//     type: String,
		//     default: null,
		// },
		disabled: {
			type: Boolean,
			default: false,
		},
		disableText: {
			type: Boolean,
			default: false,
		},
		buttonType: {
			type: String,
			default: "primary",
		},
		icon: {
			type: String,
			default: "",
		},
	},
	computed: {
		buttonClass() {
			let colorClass = "ns-button-primary";
			if (this.buttonType == "primary") {
				colorClass = "ns-button-primary";
			} else if (this.buttonType == "light") {
				colorClass = "ns-button-light";
			} else if (this.buttonType == "dark") {
				colorClass = "ns-button-dark";
			}
			return colorClass;
		},
	},
	methods: {
		handleClick() {
			this.$emit("click");
		},
	},
};
</script>

<style scoped>
button {
	transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}

.ns-button-primary {
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
}

.ns-button-light {
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
	padding-top: 10px;
}

.ns-button-dark {
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
}

.float-inherit {
	float: inherit;
}
</style>
